import type { GraphConfig, SelectedGraphs } from '../../../SharedComponents/ExportDialog';
import type { GraphData } from '../../../../utils/exportUtils';
import type { AdvertisingSpendChartData, PackageTypeInfo } from './Graphs/AdvertisingSpend.utils';

export const getAdSpendGraphConfigs = (): Array<GraphConfig> => [
  {
    id: 'advertising-spend',
    label: 'Advertising spend',
  },
];

export const extractAdSpendData = (
  selectedGraphs: SelectedGraphs,
  chartData: Array<AdvertisingSpendChartData>,
  allPackageTypesPresent: Array<PackageTypeInfo>,
): Array<GraphData> => {
  const graphsData: Array<GraphData> = [];

  if (!selectedGraphs['advertising-spend']) {
    return graphsData;
  }

  const categoriesPresent = allPackageTypesPresent.map((pkg) => pkg.packageTypeString).sort();
  const columns = ['Month', 'Total Spend', ...categoriesPresent];

  const exportData = chartData.map((row) => {
    const result: Record<string, string | number> = {
      Month: row.name,
      'Total Spend': parseFloat(row.totalSpend.toFixed(2)),
    };

    categoriesPresent.forEach((category) => {
      result[category] = row[category] ? parseFloat((row[category] as number).toFixed(2)) : 0;
    });

    return result;
  });

  graphsData.push({
    name: 'Advertising_Spend',
    data: exportData,
    columns,
  });

  return graphsData;
};
